/**
 * Common Filter Hook
 * Filters messages with a simple predicate
 * Used by both incoming and outgoing pipelines
 */
import { FilterHook as BaseFilterHook } from 'edge-stream-js';
import { type HookMetadata } from '../HookMetadata';

export class FilterHook extends BaseFilterHook {
  metadata?: HookMetadata = {
    name: 'FilterHook',
    description: 'Filters messages using a configurable predicate function',
    version: '1.0.0',
    author: 'EdgeStream',
    tags: ['filtering', 'common', 'security'],
    modifiesData: false,
    impactLevel: 'high',
  };

  constructor() {
    // Accept all messages by default
    super(() => true);
  }
}
